<!-- Rename folder modal -->
<ui-dialog
    size="small"
    header="document.renameFolder"
    [open]="currentlyOpenDialog === 'FOLDER_RENAME'"
    [form]="renameFolder"
    primaryButtonLabel="{{ 'document.rename' | translate }}"
    secondaryButtonLabel="{{ 'document.cancel' | translate }}"
    (primaryButtonPressed)="renameFolder.valid && onRenameFolder()"
    (closing)="folderRename = ''; closeDialog()"
    (secondaryButtonPressed)="closeDialog(); folderRename = ''"
>
    <form #renameFolder="ngForm" class="flex col">
        <mat-form-field>
            <mat-label>{{ 'document.folderName' | translate }}</mat-label>
            <input
                matInput
                required
                name="folderName"
                placeholder="{{ currentNode?.source?.name }}"
                [(ngModel)]="folderRename"
                type="text"
            />
        </mat-form-field>
    </form>
</ui-dialog>

<!-- Delete folder modal -->
<ui-dialog
    size="small"
    header="document.folderDeletion.permanentlyDeleteFolder"
    [open]="currentlyOpenDialog === 'FOLDER_DELETE'"
    (closing)="closeDialog()"
>
    <div>
        <p>{{ 'document.folderDeletion.warning' | translate }}</p>
        @if (parentDrive?.type === driveTypeEnum.private) {
            <ul>
                <li>
                    {{ 'document.folderDeletion.signingTemplateWarning' | translate }}
                </li>
                <li>
                    {{ 'document.folderDeletion.acknowledgementWarning' | translate }}
                </li>
                <li>
                    {{ 'document.folderDeletion.offerLetterWarning.deletingWill' | translate }}
                </li>
                <ul>
                    <li>
                        {{ 'document.folderDeletion.offerLetterWarning.withdrawOffers' | translate }}
                    </li>
                    <li>
                        {{ 'document.folderDeletion.offerLetterWarning.deleteSignatures' | translate }}
                    </li>
                </ul>
            </ul>
        }
        <mat-checkbox class="delete-folder-checkbox" #canDeleteCheckbox>
            <span>{{ 'document.iUnderstandThisCannotBeUndone' | translate }}</span>
        </mat-checkbox>
    </div>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeDialog()">{{ 'document.cancel' | translate }}</ui-button>
        <ui-button type="danger" [disabled]="!canDeleteCheckbox.checked" (click)="onDeleteFolder()">{{
            'document.deletePermanently' | translate
        }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<!--Delete document modal-->
<app-company-document-deletion-modal #companyDocumentDeletionModal></app-company-document-deletion-modal>

<!---Save document modal-->
<ui-dialog
    [open]="currentlyOpenDialog === 'FILE_CREATE'"
    [form]="documentForm?.form ? documentForm.form : {}"
    [header]="getCreateDocumentModalTitle()"
    (primaryButtonPressed)="onSaveDocument(documentForm)"
    (closing)="closeDialog()"
    size="small"
    primaryButtonLabel="document.create"
    secondaryButtonLabel="cancel"
>
    <ui-banner variant="info" class="mobile-hide upload-info-banner"
        >{{
            'document.newTemplateAccessibleTo'
                | translate: { type: (getCreateDocumentType() | translate).toLowerCase() }
        }}
    </ui-banner>
    <app-company-document-form
        #documentForm
        [companyDocument]="newDocument"
        [showPublicCheckbox]="false"
        [allTags]="documentTags"
    ></app-company-document-form>
</ui-dialog>

<!-- Warning modal when moving node from private drive to public drive -->
<ui-confirmation-dialog
    #publicDataForbiddenDialog
    header="document.publicDataForbiddenHeader"
    primaryButtonLabel="document.publicDataForbiddenButton"
>
    {{ 'document.publicDataForbidden' | translate }}
</ui-confirmation-dialog>

<!-- Warning modal when moving view-only doc from public drive to private drive -->
<ui-confirmation-dialog
    #privateViewOnlyDocForbiddenDialog
    header="document.privateViewOnlyDocForbiddenHeader"
    primaryButtonLabel="document.privateViewOnlyDocForbiddenButton"
>
    {{ 'document.privateViewOnlyDocForbidden' | translate }}
</ui-confirmation-dialog>

<!-- Cannot move item error -->
<ui-confirmation-dialog #moveErrorResult [header]="moveErrorHeader" primaryButtonLabel="Ok">
    {{ moveErrorDescription | translate }}
    <ul>
        <li *ngFor="let conflict of moveConflicts">{{ conflict }}</li>
    </ul>
</ui-confirmation-dialog>

<!-- Add Document Buttons -->
<ng-template #addDocumentButton>
    @if (inSearchState || inTagsFilterState || inRecentDocumentsState) {
        <ui-button class="create-new" type="primary" [matMenu]="addDocumentsMenu" size="mobile-shrink"
            ><mat-icon svgIcon="plus" /><mat-icon class="file-icon hide-large" svgIcon="file" />
            <span class="only-large">
                {{ 'document.addDocument' | translate }}<mat-icon class="margin-left-1" svgIcon="chevronDown" />
            </span>
        </ui-button>
        <mat-menu #addDocumentsMenu xPosition="before">
            <button mat-menu-item (click)="onSelectTemplate()">
                <span class="add-documents-menu-item">
                    <mat-icon svgIcon="file" />
                    {{ 'document.addTemplate' | translate }}
                </span>
            </button>
            <button mat-menu-item (click)="redirectToBulkUploadPage(driveTypeEnum.public)">
                <span class="add-documents-menu-item">
                    <mat-icon svgIcon="file" />
                    {{ 'document.addCompanyDocument' | translate }}
                </span>
            </button>
        </mat-menu>
    } @else if (parentDrive?.type === driveTypeEnum.public) {
        <ui-button
            class="create-new"
            type="primary"
            (click)="redirectToBulkUploadPage(driveTypeEnum.public)"
            size="mobile-shrink"
            ><mat-icon svgIcon="plus" /><mat-icon class="file-icon hide-large" svgIcon="file" />
            <span class="only-large">
                {{ 'document.addCompanyDocument' | translate }}
            </span>
        </ui-button>
    } @else if (parentDrive?.type === driveTypeEnum.private) {
        <ui-button class="create-new" type="primary" (click)="onSelectTemplate()" size="mobile-shrink"
            ><mat-icon svgIcon="plus" /><mat-icon class="file-icon hide-large" svgIcon="file" />
            <span class="only-large">
                {{ 'document.addTemplate' | translate }}
            </span>
        </ui-button>
    }
</ng-template>

<!--Select Template Modal-->
<ui-dialog
    [open]="currentlyOpenDialog === 'FILE_TYPE_SELECT' && parentDrive?.type === driveTypeEnum.private"
    (closing)="closeDialog()"
    header="{{ 'document.newTemplateDocument' | translate }}"
>
    <div class="file-select-modal">
        <span class="file-select-folder">
            {{ 'document.selectTheTypeOfDocument' | translate }}
            <mat-icon class="icon private margin-left-1 margin-right-1" svgIcon="folderSign"></mat-icon>
            {{ currentFolderName() | translate }}
        </span>
        <div class="responsive-grid">
            <div class="row">
                <ui-card
                    role="button"
                    variant="outline"
                    [centered]="true"
                    [clickable]="true"
                    (click)="onSelectDocumentCreationType(documentType.offerLetter)"
                    class="columns-4 small-columns-12 select-document-ui-card"
                >
                    <mat-icon class="icon-template" svgIcon="offerLetter"></mat-icon>
                    <h3 class="margin-bottom-1">{{ 'document.offerLetterTemplate' | translate }}</h3>
                    {{ 'document.anOfferLetterTemplateWithPersonalizedLetterFieldsThatCa' | translate }}
                </ui-card>
                <ui-card
                    role="button"
                    variant="outline"
                    [centered]="true"
                    [clickable]="true"
                    (click)="onSelectDocumentCreationType(documentType.standardSigningDocument)"
                    class="columns-4 small-columns-12 select-document-ui-card"
                >
                    <mat-icon class="icon-template" svgIcon="signingTemplate"></mat-icon>
                    <h3 class="margin-bottom-1">{{ 'document.signingTemplate' | translate }}</h3>
                    {{ 'document.aReusableTemplateThatRequiresLegallyBindingSignaturesFro' | translate }}
                </ui-card>
                <ui-card
                    role="button"
                    variant="outline"
                    [centered]="true"
                    [clickable]="true"
                    (click)="redirectToBulkUploadPage(driveTypeEnum.private)"
                    class="columns-4 small-columns-12 select-document-ui-card"
                >
                    <mat-icon class="icon-template" svgIcon="acknowledgement"></mat-icon>
                    <h3 class="margin-bottom-1">{{ 'document.acknowledgementDocument' | translate }}</h3>
                    {{ 'document.nonLegallyBindingAcknowledgement' | translate }}
                </ui-card>
            </div>
        </div>
    </div>
</ui-dialog>

<!-- New Folder modal -->
<ui-dialog
    size="small"
    #newFolderDialog
    header="{{ 'document.createANewFolderIn' | translate: { folderName: currentFolderName() | translate } }}"
    [open]="currentlyOpenDialog === 'FOLDER_CREATE'"
    primaryButtonLabel="{{ 'document.createFolder' | translate }}"
    secondaryButtonLabel="{{ 'document.cancel' | translate }}"
    (closing)="folderCreateName = ''; closeDialog()"
    [form]="newFolderName"
    (primaryButtonPressed)="newFolderName.valid && newFolder()"
    (secondaryButtonPressed)="closeDialog(); folderCreateName = ''"
>
    <form #newFolderName="ngForm" class="flex col">
        <mat-form-field>
            <mat-label>{{ 'document.folderName' | translate }}</mat-label>
            <input
                matInput
                required
                name="folderName"
                placeholder="{{ 'document.newFolder' | translate }}"
                [(ngModel)]="folderCreateName"
                type="text"
            />
        </mat-form-field>
    </form>
</ui-dialog>

<!-- Tag menu -->
<ng-template #tagListing>
    <app-document-tag-menu
        [(documentTags)]="documentTags"
        [selectedTags]="parentSelectedTags"
        label="document.rename"
        (select)="filterByTags($event)"
    ></app-document-tag-menu>
</ng-template>

<!-------------------------------------------------------------------------------------------------------------------->

<div [class]="pageContainerClasses">
    <div class="header" [class.activeSearch]="inSearchState">
        <app-header title="{{ 'document.documents' | translate }}" [hideOverflow]="true" />
        <!-- Search Bar -->
        <app-search #searchBar placeholder="document.searchDocuments" (onSearch)="onSearch($event)"></app-search>
        <div @widthExpand *ngIf="inSearchState && !inRecentDocumentsState">
            <ui-button size="mobile-shrink" class="clear-search" type="ghost" (click)="onClearSearchFilters()">
                <mat-icon svgIcon="close" />
                <span class="only-large">{{ 'document.clear' | translate }}</span>
            </ui-button>
        </div>
        <!-- Filters aka Tags Desktop View -->
        <ui-button class="only-large" type="filter" id="tags-filter" data-test-id="tags-listing" [matMenu]="filter">
            <mat-icon [svgIcon]="inTagsFilterState ? 'filterListActive' : 'filterList'"></mat-icon>
            <span>{{ 'filters' | translate }}</span>
        </ui-button>
        <mat-menu #filter xPosition="before">
            <!-- Prevent menu from closing until user clicks outside of it -->
            <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                <ng-container [ngTemplateOutlet]="tagListing" />
            </div>
        </mat-menu>
        <!-- Add Document -->
        <ng-container *ngTemplateOutlet="addDocumentButton"></ng-container>
    </div>

    <ui-card
        class="document-folders-index-view"
        [withSpacing]="false"
        [class.hasTags]="documentTags.length"
        cdkDropListGroup
    >
        <!-- Sidebar -->
        <div class="sidepanel">
            <div
                role="button"
                class="quick-link mobile-hide"
                [class.recent-documents-selected]="inRecentDocumentsState"
                (click)="onRecentDocuments()"
            >
                <mat-icon class="icon" svgIcon="clockSimple"></mat-icon>
                <span>{{ 'account.recentDocuments' | translate }}</span>
            </div>
            <div class="divider mobile-hide"></div>
            <app-document-folders-sidebar-v2
                class="folders-sidebar"
                #sidebarComponent
                [tableParentNode]="tableParentNode"
                [sidebarDrives]="sidebarDrives"
                (loadTableBasedOnSelectedNode)="onClearSearchFilters(); load($event)"
                (reloadTableOnSideBarActions)="reloadTableOnSidebarActions()"
                [deselectEverything]="inSearchState || inTagsFilterState || inRecentDocumentsState"
                (recentDocumentsClicked)="onRecentDocuments()"
                [inRecentDocumentsState]="inRecentDocumentsState"
            ></app-document-folders-sidebar-v2>
        </div>

        <!-- Table -->
        <div class="folders-index-table loadable" [class.loading]="isLoading || isSearchTableLoading || isTableLoading">
            <div class="table-header">
                <div class="header-wrapper">
                    <!-- Breadcrumb navigation -->
                    @if (!inSearchState && !inTagsFilterState) {
                        <div class="breadcrumb only-large">
                            @for (crumb of breadcrumb; track crumb; let isFirst = $first) {
                                @if (!isFirst) {
                                    <mat-icon svgIcon="chevronRight"></mat-icon>
                                }
                                @if (crumb.node) {
                                    <a (click)="onClick(crumb.node)"
                                        ><span>{{ crumb.name | translate }}</span></a
                                    >
                                } @else if (isFirst) {
                                    <a (click)="onRecentDocuments()"
                                        ><span>{{ crumb.name | translate }}</span></a
                                    >
                                } @else {
                                    <span>{{ crumb.name | translate }}</span>
                                }
                            }
                        </div>
                    }

                    <div class="header-details">
                        <ng-container
                            *ngIf="
                                (inSearchState && searchQuery) ||
                                    (inTagsFilterState && selectedTags.length) ||
                                    inRecentDocumentsState;
                                else showNodeName
                            "
                        >
                            <!-- Search Header -->
                            <h2>
                                <span>
                                    @if (inSearchState && searchQuery) {
                                        {{ 'document.searchResultsSearchQuery' | translate: { searchQuery } }}
                                    } @else if (inTagsFilterState) {
                                        {{ 'document.searchResults' | translate }}
                                    } @else if (inRecentDocumentsState) {
                                        {{ 'account.recentDocuments' | translate }}
                                    }
                                </span>
                            </h2>
                        </ng-container>

                        <!-- Default Table Header -->
                        <ng-template #showNodeName>
                            <ng-container
                                *ngIf="parentDrive?.type === driveTypeEnum.public; else showPrivateDriveOrFolderIcon"
                                class="row"
                            >
                                <h2 *ngIf="tableParentNode?.isDrive()">
                                    <span>{{ driveTypeDisplay['public'] | translate }}</span>
                                </h2>
                                <h2 *ngIf="tableParentNode?.isFolder()">
                                    <span>{{ tableParentNode?.name }}</span>
                                </h2>
                            </ng-container>
                        </ng-template>

                        <ng-template #showPrivateDriveOrFolderIcon>
                            <h2 *ngIf="tableParentNode?.isDrive()">
                                <span>{{ driveTypeDisplay['private'] | translate }}</span>
                            </h2>
                            <h2 *ngIf="tableParentNode?.isFolder()">
                                <span>{{ tableParentNode?.name }}</span>
                            </h2>
                        </ng-template>

                        <!-- Paginator, buttons -->
                        @if (!inSearchState && !inTagsFilterState && table?.paginator) {
                            <div class="buttons">
                                <app-pagination
                                    [total]="table.paginator.total"
                                    [current]="table.paginator.page"
                                    [limit]="table.paginator.pageSize"
                                    (pageChange)="table.paginator.page = $event"
                                    [disableLoad]="isLoading"
                                />
                                <div *permission="companyDocumentsEditPermission">
                                    <ui-button
                                        class="create-new"
                                        size="mobile-shrink"
                                        type="outline"
                                        (click)="currentlyOpenDialog = 'FOLDER_CREATE'"
                                        ><mat-icon svgIcon="plus" /><mat-icon
                                            class="file-icon hide-large"
                                            svgIcon="folder"
                                        /><span class="only-large">{{
                                            'document.addFolder' | translate
                                        }}</span></ui-button
                                    >
                                </div>
                            </div>
                        } @else if (tableBasedOnSearchQuery?.paginator) {
                            <app-pagination
                                [total]="tableBasedOnSearchQuery.paginator.total"
                                [current]="tableBasedOnSearchQuery.paginator.page"
                                [limit]="tableBasedOnSearchQuery.paginator.pageSize"
                                (pageChange)="tableBasedOnSearchQuery.paginator.page = $event"
                                [disableLoad]="isLoading"
                            />
                        }
                    </div>

                    <!-- Filter Badges -->
                    <ng-container *ngIf="inTagsFilterState && selectedTags.length">
                        <div class="only-large chip-list">
                            <mat-chip-set>
                                <mat-chip *ngFor="let selectedTag of selectedTags">
                                    {{ selectedTag.name }}
                                    <div
                                        matChipRemove
                                        role="button"
                                        class="flex"
                                        (click)="removeTag(selectedTag)"
                                        attr.aria-label="{{ 'remove' | translate }} {{ selectedTag.name }}"
                                    >
                                        <mat-icon svgIcon="close" />
                                    </div>
                                </mat-chip>
                                <mat-chip-option *ngIf="selectedTags.length" (click)="removeAllTags()">
                                    {{ 'dashboard.clearFilters' | translate }}
                                </mat-chip-option>
                            </mat-chip-set>
                        </div>
                    </ng-container>
                    @if (!inSearchState && !inTagsFilterState && tableParentNode?.isDrive()) {
                        <div class="drive-description">
                            @if (parentDrive?.type === driveTypeEnum.public) {
                                <span>{{ 'document.driveDescription.companyDocuments' | translate }}</span>
                            } @else if (parentDrive?.type === driveTypeEnum.private) {
                                <span>{{ 'document.driveDescription.templateLibrary' | translate }}</span>
                            }
                        </div>
                    }
                </div>
            </div>

            <!-- Filters aka Tags Mobile View -->
            <div *ngIf="documentTags.length" class="tags hide-large">
                <ng-container [ngTemplateOutlet]="tagListing" />
            </div>

            <ng-container *ngIf="hasAnyFilesOrFolders; else noFilesOrFolders">
                <div [class.scrollable-table-container]="!isMobile">
                    @if (tableBasedOnSearchQuery && (inSearchState || inTagsFilterState)) {
                        <!-- On Search or tags filter, load table based on search query -->
                        <app-table
                            (rowClicked)="onClick($event)"
                            [noPadding]="true"
                            [useStickyHeader]="false"
                            [showOffset]="false"
                            [showActionsPadding]="false"
                            [embedded]="true"
                            *ngIf="!isLoading && !isSearchTableLoading"
                            [showLoading]="false"
                            [table]="tableBasedOnSearchQuery"
                            class="table"
                            [showSearch]="false"
                            (menuItemSelected)="menuAction($event)"
                            (dropEvent)="onDrop($event)"
                            (rowDragEvent)="dragStart($event)"
                            [isResponsive]="true"
                            [showPagination]="false"
                        >
                            <app-empty-state
                                class="empty-state"
                                src="/assets/illustrations/documents_empty.png"
                                label="document.thisFolderIsEmpty"
                            ></app-empty-state
                        ></app-table>
                    } @else {
                        <!-- Not in search mode or tags filter mode, load normal table -->
                        <app-table
                            (rowClicked)="onClick($event)"
                            [noPadding]="true"
                            [useStickyHeader]="false"
                            [showOffset]="false"
                            [showActionsPadding]="false"
                            [embedded]="true"
                            *ngIf="!isLoading && !isTableLoading"
                            [showLoading]="false"
                            [table]="table"
                            class="table"
                            [showSearch]="false"
                            (menuItemSelected)="menuAction($event)"
                            (dropEvent)="onDrop($event)"
                            (rowDragEvent)="dragStart($event)"
                            [isResponsive]="true"
                            [showPagination]="false"
                        >
                            <app-empty-state
                                class="empty-state"
                                src="/assets/illustrations/documents_empty.png"
                                label="document.thisFolderIsEmpty"
                            ></app-empty-state
                        ></app-table>
                    }
                </div>
            </ng-container>
        </div>

        <ng-template #noFilesOrFolders>
            <div class="no-files-or-folders">
                <img src="/assets/illustrations/folder-with-sheet.png" />
                <h3 class="centered">{{ 'document.emptyStateTitle' | translate }}</h3>
                <div>{{ 'document.emptyStateLine1' | translate }}</div>
                <div>{{ 'document.emptyStateLine2' | translate }}</div>

                <div class="flex align-items-center margin-top-1">
                    <ui-button
                        class="create-new"
                        size="mobile-shrink"
                        type="outline"
                        [externalLink]="true"
                        [url]="learnMoreUrl"
                        [openInNewTab]="true"
                    >
                        <span>{{ 'document.learnMore' | translate }}</span>
                    </ui-button>
                    <ui-button
                        class="create-new"
                        size="mobile-shrink"
                        type="outline"
                        (click)="currentlyOpenDialog = 'FOLDER_CREATE'"
                        ><mat-icon svgIcon="plus" /><mat-icon class="file-icon hide-large" svgIcon="folder" /><span
                            class="only-large"
                            >{{ 'document.addFolder' | translate }}</span
                        ></ui-button
                    >
                    <ng-container *ngTemplateOutlet="addDocumentButton"></ng-container>
                </div>
            </div>
        </ng-template>
    </ui-card>
</div>
